<template>
  <v-dialog
    v-model="eventId"
    max-width="700px"
    @click:outside="$emit('close-dialog')"
    @keydown.esc="$emit('close-dialog')"
  >
    <v-card v-if="isLoad">
      <v-card-title class="text-h5">
        {{ event.employee.fullname }}
      </v-card-title>
      <v-card-subtitle>
        <v-btn x-small color="green lighten-3">
          Позиция: {{ event.employee.role }}
        </v-btn>
        <br>
        <v-btn x-small color="green lighten-3">
          ИИН: {{ event.employee.iin }}
        </v-btn>
        <br>
        <v-btn x-small color="green lighten-3">
          Стаж: {{ event.experience }}
        </v-btn>
        <br>
        <v-btn x-small color="green lighten-3">
          Явок {{ event.attendances_options.length }}
        </v-btn>
      </v-card-subtitle>
      <v-card-text>
        <v-container>
          <v-form v-if="formData">
            <v-row class="mb-3">
              <v-col cols="6">
                <v-text-field
                  v-model="formData.regular"
                  label="Регуляр"
                >
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="formData.bonus"
                  label="Бонус"
                  @change="formData.persist = true"
                >
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-checkbox v-model="formData.persist" label="Заблокировать авто редактирование?">
                </v-checkbox>
              </v-col>
              <v-col v-if="event.attendances_options.length > 1">
                <v-select
                  v-model="formData.attendance"
                  :items="event.attendances_options"
                  item-text="department.name"
                  item-value="guid"
                  label="Основная явка"
                >
                </v-select>
              </v-col>
              <v-btn block @click="updateEvent">GO</v-btn>
            </v-row>
            <v-card
              v-for="(attendance, key) in event.attendances_options"
              :key="key"
              :class="formData.attendance && formData.attendance === attendance.guid ? 'red lighten-4' : ''"
            >
              <v-card-title>
                {{ attendance.department.name }}
              </v-card-title>
              <v-card-subtitle>
                {{ attendance.comment }}
              </v-card-subtitle>
              <v-card-text>
                <div class="d-flex justify-space-between">
                  <div>
                    С: {{ attendance.date_from }}
                    <br>
                    До: {{ attendance.date_to }}
                  </div>
                  <div class="d-flex justify-space-between">
                    <div class="mr-4">
                      <v-icon large>
                        mdi-account-supervisor
                      </v-icon>
                      {{ attendance.employee_count }}
                    </div>
                    <div>
                      <v-icon large>mdi-cash-register</v-icon>
                      {{ attendance.cashshift }}
                    </div>

                  </div>
                </div>
              </v-card-text>
            </v-card>
            <!--            <h1>Типа checkbox</h1>-->
            <!--            <h1>Тут будет блок(card) с инфой о явке(Торг точка. время прихода, ухода, касса точки и пол сотрудников на точке)</h1>-->
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EventDialogForm",
  props: {eventId: Number},
  data: () => ({
    isLoad: false,
    event: null,
    attendances_options: [],
    formData: null
  }),
  mounted() {
    this.$api.getEventById(this.eventId)
      .then(response => {
        this.isLoad = true
        this.event = response.data
        this.formData = {
          regular: response.data.regular,
          bonus: response.data.bonus,
          attendance: response.data.attendance ? response.data.attendance.guid : '',
          persist: response.data.persist
        }
      })
  },
  methods: {
    updateEvent() {
      this.$api.updateEventById(this.eventId, this.formData)
        .then(() => {
          this.$emit('close-dialog')
          this.$root.$refs.cashshiftTable.getData()
        })
    }
  }
}
</script>

<style scoped>

</style>